module.exports = __webpack_public_path__ + "img/Easy Return Line.c8a0663f.svg";